import React from "react";
import UserWrapper from "./user.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import PosConnectionsTable from "components/posIntegrations/PosConnectionsTable";

const PosConnections = props => {
  return (
    <UserWrapper {...props}>
      <PageTitle
        title="sidebar.posConnections"
        className="plr-15"
        breadCrumb={[
          { name: "sidebar.dashboard" },
          { name: "sidebar.posIntegrations" },
          { name: "sidebar.posConnections" }
        ]}
      />
      <div className="user-tbl">
        <PosConnectionsTable {...props} />
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(PosConnections);

